import React, { Component } from 'react'
import cx from 'classnames'

import { Avatar } from '@driftt/tide-core'
import PlaceholderAvatar from 'shared-web/src/components/Avatar'
import OnlineIndicator from './OnlineIndicator'

import * as style from './style'

export default class EndUserAvatar extends Component {
  render() {
    const {
      className,
      endUser,
    } = this.props

    if (!endUser) {
      return (
        <div className={cx(style.placeholderAvatar, className)}>
          <PlaceholderAvatar />
        </div>
      )
    }

    return (
      <div className={cx(style.endUserAvatar, className)}>
        <Avatar user={endUser} size="small" />
        <OnlineIndicator className="onlineIndicator" endUser={endUser} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/conversation/ContactSideBar/Person/Profile/EndUserAvatar/index.js